import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import { Form, Drawer, Button, Input, Select } from "antd";
import { CloudServicesEnum, cloudServices } from "common/cloudServices";

const FormItem = Form.Item;
const Option = Select.Option;

@inject("rootStore")
@Form.create({
})
@observer
export default class AddCloudAccountDrawer extends Component {
    constructor(props) {
        super(props);
    }

    addAccount = () => {
        this.props.form.validateFieldsAndScroll((err, vals) => {
            if (err != null) {
                return;
            }

            let info = null;

            if (vals.service == CloudServicesEnum.S3) {
                let data = {
                    accessKey: vals.accessKey,
                    secretKey: vals.secretKey
                }
                info = JSON.stringify(data);
            } else if (vals.service == CloudServicesEnum.Azure) {
                let data = {
                    connectionString: vals.connectionString,
                }
                info = JSON.stringify(data)
            } else if (vals.service == CloudServicesEnum.Google) {
                let data = {
                    credentials: vals.credentials,
                }
                info = JSON.stringify(data)
            }
            let payload = {
                friendlyName: vals.friendlyName,
                service: vals.service,
                info: info,
            }

            this.props.form.resetFields();
            const {
                rootStore: { cloudAccountsStore }
            } = this.props;

            cloudAccountsStore.remoteAddAccount(payload);

            // let lang = findLanguageByShortCode(vals.language);

            // this.props.generateArticles({
            // 	articleSource: "OpenAI",
            // 	contentGroupId: this.props.contentGroupId,
            // 	inputInfo: JSON.stringify({
            // 		topic: vals.topic,
            // 		keywords: vals.keywords,
            // 		nArticles: vals.nArticles,
            // 		language: lang.label,
            // 	})
            // });

            this.props.form.resetFields();
        });
    };

    hideDrawer = () => {
        this.props.form.resetFields();
        this.props.hideDrawer();
    };

    render() {
        const {
            rootStore: { cloudAccountsStore }
        } = this.props;

        const {
            ui: { addAccountDialogVisible, addingAccount }
        } = this.props;
        const ui = cloudAccountsStore.ui;

        let currentService = this.props.form.getFieldValue("service");

        if (!currentService) {
            currentService = "S3";
        }

        let infoSection = <Fragment />;
        let height = 600;
        switch (currentService) {
            case CloudServicesEnum.S3:
                height = 550;
                infoSection = (
                    <Fragment>
                        <Form.Item label="Access Key">
                            {this.props.form.getFieldDecorator("accessKey", {
                                rules: [
                                    {
                                        required: true,
                                        message: "You need to enter access key"
                                    }
                                ]
                            })(<Input />)}
                        </Form.Item>
                        <Form.Item label="Secret Key">
                            {this.props.form.getFieldDecorator("secretKey", {
                                rules: [
                                    {
                                        required: true,
                                        message: "You need to enter secret key"
                                    }
                                ]
                            })(<Input />)}
                        </Form.Item>
                    </Fragment>
                );
                break;
            case CloudServicesEnum.Google:
                height = 450;
                infoSection = (
                    <Fragment>
                        <Form.Item label="Credentials">
                            {this.props.form.getFieldDecorator("credentials", {
                                rules: [
                                    {
                                        required: true,
                                        message: "You need to enter Google credentials"
                                    }
                                ]
                            })(<Input />)}
                        </Form.Item>
                    </Fragment>
                );
                break;
            case CloudServicesEnum.Azure:
                height = 450;
                infoSection = (
                    <Fragment>
                        <Form.Item label="Connection String">
                            {this.props.form.getFieldDecorator("connectionString", {
                                rules: [
                                    {
                                        required: true,
                                        message: "You need to enter Azure connection string"
                                    }
                                ]
                            })(<Input />)}
                        </Form.Item>
                    </Fragment>
                );
                break;

        }

        return (
            <Drawer
                title="Add Cloud Account"
                placement="top"
                destroyOnClose={true}
                // closable={false}
                onClose={this.hideDrawer}
                visible={addAccountDialogVisible}
                height={height}
            >
                <Form>
                    <Form.Item label="Friendly Name">
                        {this.props.form.getFieldDecorator("friendlyName", {
                            rules: [
                                {
                                    required: true,
                                    message: "You need to enter a friendly name to identify the account. You can use email for example."
                                }
                            ]
                        })(<Input placeholder="A friendly name (for example: email) to identify the account" />)}
                    </Form.Item>
                    <Form.Item
                        label="Service"
                        help="Select cloud service"
                    >
                        {this.props.form.getFieldDecorator(
                            "service",
                            {
                                initialValue: currentService,
                                rules: [
                                    {
                                        required: true,
                                        message:
                                            "Please select a cloud service"
                                    }
                                ]
                            }
                        )(
                            <Select
                                style={{ width: 200 }}
                                placeholder="Select a cloud service"
                                notFoundContent="Select a cloud service"
                            >
                                {cloudServices.map(item => {
                                    return (
                                        <Option
                                            value={item.value}
                                            key={item.value}
                                        >
                                            {item.label}
                                        </Option>
                                    );
                                })}
                            </Select>
                        )}
                    </Form.Item>
                    {infoSection}
                    <div
                        style={{
                            position: "absolute",
                            bottom: 0,
                            width: "100%",
                            borderTop: "1px solid #e8e8e8",
                            padding: "10px 16px",
                            textAlign: "left",
                            left: 0,
                            background: "#fff",
                            borderRadius: "0 0 4px 4px"
                        }}
                    >
                        <Button
                            style={{
                                marginRight: 8
                            }}
                            onClick={this.hideDrawer}
                        >
                            Cancel
                        </Button>
                        <Button
                            type="primary"
                            onClick={this.addAccount}
                            loading={addingAccount}
                        >
                            Add Account
                        </Button>
                    </div>
                </Form>
            </Drawer>
        );
    }
}
